
import { Component, mixins } from 'nuxt-property-decorator';
import { MultiRowsBlockModel } from 'fourwaves-shared';
import ContentBlockMixin from '../../ContentBlockMixin';
import MultiRowsBlockList from './MultiRowsBlockList.vue';

@Component({
  components: {
    MultiRowsBlockList,
  },
})
export default class MultiRowsBlock extends mixins(ContentBlockMixin<MultiRowsBlockModel>) {}
